import React from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { TRIGGER_PLAY_QUEUE } from '../../actions/Playback';
export default function PlayQueueButton(props) {
    var _a;
    const dispatch = useDispatch();
    const { mediaId } = useSelector((state) => state.Media, shallowEqual);
    const { isPlayQueueOpen } = useSelector((state) => state.PlayQueue, shallowEqual);
    const { visualPlayQueue } = useSelector((state) => state.PlaybackStates);
    const triggerPlayQueue = () => dispatch({ type: TRIGGER_PLAY_QUEUE, payload: { mediaId } });
    if (!visualPlayQueue) {
        return React.createElement("div", { style: { display: 'none' } });
    }
    return (React.createElement("music-button", { id: "play-queue-button", "icon-only": true, onmusicActivate: triggerPlayQueue, "icon-name": isPlayQueueOpen ? "caretdown" : "playqueue", disabled: !isPlayQueueOpen && ((_a = visualPlayQueue) === null || _a === void 0 ? void 0 : _a.isDisabled), variant: "primary", size: props.size || 'small' }));
}
;
